import { memo } from 'react';

import FeedRunsList from './FeedRunsList';

export default memo(FeedRunsList);
